module.exports = __webpack_public_path__ + "static/media/crystal.87a590ec.png";